export default __webpack_public_path__ + "static/customer-logos-3c234ba80c1ba9539dcfa728330b07f5.jpg";